import React from 'react';
import clsx from 'clsx';
import SesamLink from 'Common/Links/SesamLink';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

import type { NavBarMenuItemGroup, NavBarMenuItemType } from '../../types/common.types';

import { TestID } from '../../testID';

type Classes = ClassNameMap<
  | 'navbarMenuGroup'
  | 'navbarMenuLabel'
  | 'navbarMenuItem'
  | 'navbarMenuLinkActive'
  | 'navbarMenuLink'
  | 'navbarMenuLinkDisabled'
>;

const MenuItem: React.FC<{ menuItem: NavBarMenuItemType; classes: Classes }> = ({
  menuItem,
  classes,
}) => (
  <li className={classes.navbarMenuItem} key={menuItem.to}>
    <SesamLink
      activeClassName={classes.navbarMenuLinkActive}
      className={clsx([
        classes.navbarMenuLink,
        menuItem.disabled && classes.navbarMenuLinkDisabled,
      ])}
      title={menuItem.title}
      to={menuItem.to}
      buttonLink={true}
    >
      {menuItem.icon}
      <span data-testid={`${TestID.NavBarMenuItem}-${menuItem.title}`}>{menuItem.title}</span>
    </SesamLink>
  </li>
);

export const NavBarMenuItem: React.FC<{ menuItemGroup: NavBarMenuItemGroup; classes: Classes }> = ({
  menuItemGroup,
  classes,
}) => {
  if (menuItemGroup.label) {
    return (
      <li className={classes.navbarMenuGroup} key={menuItemGroup.label}>
        <h2 className={classes.navbarMenuLabel}>{menuItemGroup.label}</h2>
        <ul>
          {menuItemGroup.items.map((menuItem) => (
            <MenuItem key={menuItem.id} menuItem={menuItem} classes={classes} />
          ))}
        </ul>
      </li>
    );
  }

  return (
    <>
      {menuItemGroup.items.map((menuItem) => (
        <MenuItem key={menuItem.id} menuItem={menuItem} classes={classes} />
      ))}
    </>
  );
};
